var _g, _rect, _defs;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgLeftHalf(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 295,
    height: 269,
    viewBox: "0 0 295 269",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_14008_88904)"
  }, /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter0_d_14008_88904)"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 295,
    height: 407,
    rx: 8,
    fill: "#EEF0FC"
  })), /*#__PURE__*/React.createElement("rect", {
    width: 299,
    height: 44,
    fill: "#DADCE8"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 16,
    y: 59,
    width: 167,
    height: 8,
    rx: 1,
    fill: "#DADCE8"
  }), /*#__PURE__*/React.createElement("rect", {
    opacity: 0.6,
    x: 16,
    y: 73,
    width: 220,
    height: 8,
    rx: 1,
    fill: "#DADCE8"
  }), /*#__PURE__*/React.createElement("rect", {
    opacity: 0.6,
    x: 16,
    y: 89,
    width: 263,
    height: 8,
    rx: 1,
    fill: "#DADCE8"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 16.5,
    y: 121.5,
    width: 120,
    height: 123,
    rx: 3.5,
    fill: "white"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 16.5,
    y: 121.5,
    width: 120,
    height: 123,
    rx: 3.5,
    fill: "#2356F6",
    fillOpacity: 0.15
  }), /*#__PURE__*/React.createElement("rect", {
    x: 16.5,
    y: 121.5,
    width: 120,
    height: 123,
    rx: 3.5,
    stroke: "#2356F6",
    strokeLinecap: "round",
    strokeDasharray: "2 5"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.5,
    d: "M37.8293 163.128C39.1733 163.128 40.2613 162.44 40.5813 161.384V163H43.0773V158.472C43.0773 157.64 42.4693 156.712 41.3333 156.712H38.1813V158.792H40.1813C40.3413 158.792 40.4373 158.904 40.4373 159.08C40.4373 159.864 39.1893 160.856 37.9893 160.856C36.3093 160.856 34.9493 159.464 34.9493 157.4C34.9493 155.336 36.3093 154.104 38.0373 154.104C39.3653 154.104 40.1813 154.792 40.3253 155.88H43.1093C43.0133 153.384 40.9813 151.672 38.0693 151.672C35.0293 151.672 32.2613 153.576 32.2613 157.4C32.2613 161.224 34.9333 163.128 37.8293 163.128ZM44.5325 163H47.1725V154.936H44.5325V163ZM44.4845 153.944H47.2365V151.352H44.4845V153.944ZM50.8826 163H53.2186L56.1626 154.936H53.4746L52.0506 159.624L50.6106 154.936H47.9386L50.8826 163ZM56.9231 163H59.5631V154.936H56.9231V163ZM56.8751 153.944H59.6271V151.352H56.8751V153.944ZM61.0013 163H63.6413V158.552C63.6413 157.752 64.2013 157.144 65.0013 157.144C65.8013 157.144 66.3613 157.752 66.3613 158.552V163H69.0013V157.928C69.0013 156.136 67.8173 154.808 66.0093 154.808C64.9533 154.808 64.1053 155.24 63.6413 155.864V154.936H61.0013V163ZM73.9588 163.128C74.7908 163.128 75.5428 162.84 75.9748 162.312V163.208C75.9748 163.816 75.5908 164.248 75.0628 164.248H71.3508V166.264H75.5428C77.3988 166.264 78.5988 165.192 78.5988 163.528V154.936H75.9588V155.576C75.5268 155.112 74.8548 154.808 73.9108 154.808C71.6388 154.808 70.1828 156.392 70.1828 158.968C70.1828 161.544 71.6388 163.128 73.9588 163.128ZM72.7588 158.968C72.7588 157.8 73.4148 157.048 74.4227 157.048C75.4468 157.048 76.1028 157.8 76.1028 158.968C76.1028 160.136 75.4468 160.888 74.4227 160.888C73.4148 160.888 72.7588 160.136 72.7588 158.968ZM83.6479 163H86.4959V158.648H90.4639V156.216H86.4959V154.232H91.5359V151.8H83.6479V163ZM95.8431 163.128C98.3551 163.128 100.163 161.352 100.163 158.968C100.163 156.584 98.3551 154.808 95.8431 154.808C93.3311 154.808 91.5231 156.584 91.5231 158.968C91.5231 161.352 93.3311 163.128 95.8431 163.128ZM94.1631 158.968C94.1631 157.816 94.8351 157.048 95.8431 157.048C96.8511 157.048 97.5231 157.816 97.5231 158.968C97.5231 160.12 96.8511 160.888 95.8431 160.888C94.8351 160.888 94.1631 160.12 94.1631 158.968ZM105.236 157.112H106.644V154.936H105.796C104.9 154.936 104.308 155.192 103.844 156.152V154.936H101.204V163H103.844V158.92C103.844 157.784 104.356 157.112 105.236 157.112ZM107.579 163H110.219V158.488C110.219 157.592 110.715 157.016 111.467 157.016C112.219 157.016 112.715 157.592 112.715 158.488V163H115.355V158.488C115.355 157.592 115.851 157.016 116.603 157.016C117.355 157.016 117.851 157.592 117.851 158.488V163H120.491V157.64C120.491 156.152 119.323 154.808 117.563 154.808C116.235 154.808 115.259 155.464 114.827 156.168C114.395 155.288 113.675 154.808 112.443 154.808C111.419 154.808 110.699 155.256 110.219 155.896V154.936H107.579V163Z",
    fill: "#2356F6"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 160,
    y: 121,
    width: 54,
    height: 8,
    rx: 1,
    fill: "#DADCE8"
  }), /*#__PURE__*/React.createElement("rect", {
    opacity: 0.6,
    x: 160,
    y: 137,
    width: 107,
    height: 8,
    rx: 1,
    fill: "#DADCE8"
  }), /*#__PURE__*/React.createElement("rect", {
    opacity: 0.6,
    x: 160,
    y: 169,
    width: 114,
    height: 8,
    rx: 1,
    fill: "#DADCE8"
  }), /*#__PURE__*/React.createElement("rect", {
    opacity: 0.6,
    x: 160,
    y: 215,
    width: 119,
    height: 8,
    rx: 1,
    fill: "#DADCE8"
  }), /*#__PURE__*/React.createElement("rect", {
    opacity: 0.6,
    x: 160,
    y: 185,
    width: 71,
    height: 8,
    rx: 1,
    fill: "#DADCE8"
  }), /*#__PURE__*/React.createElement("rect", {
    opacity: 0.6,
    x: 160,
    y: 231,
    width: 71,
    height: 8,
    rx: 1,
    fill: "#DADCE8"
  }), /*#__PURE__*/React.createElement("rect", {
    opacity: 0.6,
    x: 160,
    y: 201,
    width: 107,
    height: 8,
    rx: 1,
    fill: "#DADCE8"
  }), /*#__PURE__*/React.createElement("rect", {
    opacity: 0.6,
    x: 160,
    y: 153,
    width: 119,
    height: 8,
    rx: 1,
    fill: "#DADCE8"
  }))), _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 0.5,
    y: 0.5,
    width: 294,
    height: 268,
    rx: 7.5,
    stroke: "#DADCE8"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("filter", {
    id: "filter0_d_14008_88904",
    x: -34,
    y: -30,
    width: 363,
    height: 475,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dy: 4
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 17
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "out"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.1 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "BackgroundImageFix",
    result: "effect1_dropShadow_14008_88904"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "effect1_dropShadow_14008_88904",
    result: "shape"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_14008_88904"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 295,
    height: 269,
    rx: 8,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLeftHalf);
export default __webpack_public_path__ + "static/media/LeftHalf.a7d51b785b3f581f46853beddf02b4a0.svg";
export { ForwardRef as ReactComponent };